import React from 'react';
import Loading from '../../../../_shared/components/Loading';
import { StyledTradeCard } from '../../../../_shared/components/ListCard/Styles';

import { StyledBox, StyledFooter, StyledThumbnail } from './Styles';

const TradeCardLoading = () => (
  <StyledTradeCard>
    <StyledThumbnail>
      <Loading width="135px" height="135px" />
      <StyledBox>
        <Loading width="266px" height="29px" />
        <div />
        <Loading width="266px" height="29px" />
        <StyledFooter />
      </StyledBox>
    </StyledThumbnail>
  </StyledTradeCard>
);

export default TradeCardLoading;
